module.exports = __webpack_public_path__ + "static/media/HCMM422.fcf604ea.jpg";